module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("French War Graves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are no French National Cemeteries in the area covered by this guidebook but the visitor will find the concrete white grave markers used by the French "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ministere des Anciens Combattants et Victims de Guerr")]), _vm._v("e in a number of CWGC cemeteries and plots. Typical of these is the headstone in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Loos British Cemetery")]), _vm._v(" commemorating "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jean Naveau")]), _vm._v(" who was killed on 8 November 1915.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("German Cemeteries")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The German War Graves Commission – "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Volksbund Deutsche Kriegsgräberfürsorge")])]), _vm._v(" – is responsible for the maintenance and upkeep of German war graves in Europe and North Africa. The German cemeteries are in stark contrast to the CWGC cemeteries in that they often exude a dark and sombre ambiance exacerbated by the black grave markers bearing the name, rank, date of death and occasionally the unit. Like many French cemeteries, they often contain mass graves for the unidentified and headstones can carry up to three or four names on each one. We would recommend you visit the German cemeteries at "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Laventie")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Sailly-sur-la-Lys, Wicres")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Illies")]), _vm._v(" as they can provide the battlefield tourist with a greater understanding of the huge loss of life that occurred on both sides of the conflict.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311c2360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11_fm026.vue
// module id = 90
// module chunks = 0